module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-ExtraLightItalic-c714639debaffdcb8a2994ff978b136c.woff";